var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function RegistrationPage() {
  this.init();
}

RegistrationPage.prototype = new Base();

RegistrationPage.prototype.init = function() {
  var $registrationPage = $('[data-registration-page]');
  if ($registrationPage.get(0) !== undefined) {
    ko.applyBindings(
      new model($registrationPage.data('registration-page')),
      $registrationPage.get(0)
    );
  }
};

module.exports = RegistrationPage;
